import Layout from "../Layout"

const AllDraftsRoute = () => {
    return (
      <div>
        <Layout>All Drafts Route</Layout>
      </div>
    );
}

export default AllDraftsRoute